import { Info, type LucideIcon } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/modules/shared/ui/components/tooltip"

interface InfoTooltipProps {
  title: string
  description: React.ReactNode
  icon?: LucideIcon
  iconClassName?: string
  side?: "top" | "bottom" | "left" | "right"
  maxWidth?: number
}

export function InfoTooltip({
  title,
  description,
  icon: Icon = Info,
  iconClassName = "text-primary",
  side = "top",
  maxWidth = 260,
}: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className="h-3.5 w-3.5 text-muted-foreground cursor-help shrink-0" />
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className="p-0 overflow-hidden"
        style={{ maxWidth }}
      >
        <div className="px-3.5 py-2.5 space-y-1">
          <div className="flex items-center gap-2">
            <Icon className={`w-3.5 h-3.5 shrink-0 ${iconClassName}`} />
            <span className="text-[13px] font-semibold text-white leading-tight">
              {title}
            </span>
          </div>
          <p className="text-[11px] leading-relaxed text-white">
            {description}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
